import { Loader } from "semantic-ui-react";
import PrescriptionCard from "./PrescriptionCard";

export default function FilledPrescriptions({ data, loading, showProfileNames }) {

    if (loading) return <Loader active inline className="after:!border-t-gray-500" />;

    return (
        <>
            {data?.length > 0 && (
                <>
                    <h2>Filled Prescriptions:</h2>
                    <section className="gap-4 mb-4 grid grid-cols-1 sm:grid-cols-2">
                        {data.map((item) => (
                            <PrescriptionCard key={item.sid} item={item} showProfileNames={showProfileNames} />
                        ))}
                    </section>
                </>
            )}
        </>
    );
}
